module.exports = __webpack_public_path__ + "img/Side_left.542df654.jpg";